// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"loader_loaderContainer__7rnkt","cross":"loader_cross__RgmbT","shDark":"loader_shDark__cmZj8"};